export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/forum/?${queryString}`)
        // .get(`/forum?lesson_id=1`)
        .then((response) => {
          context.commit("setComments", response.data.results);
          context.commit("setCount", response.data.count);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReplies(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/forum?${queryString}`)
        // .get(`/forum?lesson_id=1`)
        .then((response) => {
          context.commit("setReplies", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  add(context, data) {
    return new Promise((resolve, reject) => {
      window.axios.post("/forum/comment", data).then(resolve).catch(reject);
    });
  },
  edit(context, data) {
    return new Promise((resolve, reject) => {
      window.axios

        .put(`/forum/comment/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getUser(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/accounts/?id=${id}`)
        .then((response) => {
          context.commit("setUser", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
